module.exports = __webpack_public_path__ + "img/home_tab_material_nor.1eabda03.png";